import { useEffect, useRef, useContext } from 'react';
// import { Image } from 'antd';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import MenuIconEdit from './MenuIconEdit';
import { SocketContext } from '../../../App';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import { Switch } from 'antd';

export default function MenuIcon(props: any) {

    const ref = useRef<any>(undefined);
    const notificationApi = useNotificationInstance();
    const { closeModal, data } = props;

    /** api服务id */
    const apiId = 'menuIcon';

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //表头
    const columnsHead = [
        {
            title: '图标',
            dataIndex: 'iconId',
            render: (text: any, record: any) => {

                //src是文本
                return (
                    <div>
                        {record.iconSrc}&nbsp;&nbsp;{record.iconName}
                    </div>
                )
                //src是图片地址
                // return (
                //     <div>
                //         <Image src={record.iconSrc} width={20} preview={false} />&nbsp;&nbsp;{record.iconName}
                //     </div>
                // )
            }
        },
        {
            title: '使用位置',
            dataIndex: 'targetKey',
        },
        {
            title: '显示位置',
            dataIndex: 'position',
            render: (text: any, record: any) => {
                if (text === 'before') {
                    return (
                        <div>前面</div>
                    )
                }
                if (text === 'after') {
                    return (
                        <div>后面</div>
                    )
                }
            }
        },
        {
            title: '数量',
            dataIndex: 'amount',
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
        {
            title: '状态',
            dataIndex: 'isUse',
            render: (text: any, record: any) => (
                <Switch checkedChildren="启用" unCheckedChildren="不启用"
                    checked={text} key={record.id}
                    onChange={(e) => handleChange(record.id, 'isUse', e)}
                />
            )
        },
    ];

    const initData = async () => {
        const currentData: initDataType = {
            apiId,
        }
        ref.current.initData(currentData);
    }

    //改变数据
    const handleChange = async (id: any, columnName: string, isValue: boolean) => {
        fetchApi.PUT(wmService, {
            apiId,
            apiExtend: "updateOne",
            apiVariable: id,
            apiData: {
                columnName,
                value: isValue,
                branchStoreId: contextData?.currentBranchStoreId
            }
        }).then(async res => {
            if (res.success) {
                antMessage('success', res.data.message, 'success');
                await initData();
            }
        }).catch(err => {
            showCustomNotification(notificationApi!, {
                type: 'error',
                message: "错误，无法保存",
                description: err.message + ' | status：' + err.errors.status,
            });
        })
    };

    const handleDelete = (record: any) => {
        fetchApi.DELETE(wmService, {
            apiId,
            apiExtend: "remove",
            apiVariable: record.id,
            apiData: {
                branchStoreId: contextData?.currentBranchStoreId
            }
        }).then(async res => {
            if (res.success) {
                antMessage('success', res.data.message, 'success');
                await initData();
            }
        }).catch(err => {
            showCustomNotification(notificationApi!, {
                type: 'error',
                message: "错误，无法保存",
                description: err.message + ' | status：' + err.errors.status,
            });
        })
    };

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '菜式图标',
        apiId,
        // showStates: true,
        columns,
        pagination: true,
        EditComponent: MenuIconEdit,
        sendPageData: {
            targetId: data.id,
            targetKey: data.path
        },
        coverHandleDelete: handleDelete,
    };

    return (
        <>
            <AntDraggableModal
                title={'菜式图标'}
                open={true}
                okText='关闭'
                // cancelText={stringHandle.isUndefined()}            
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={() => closeModal(true)}
                closable={false}
                maskClosable={false}
                width={1200}
            >
                <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>
            </AntDraggableModal>
        </>
    )
}